<mat-form-field [appearance]="appearance" [floatLabel]="floatLabel" class="sa-form-field fit-parent"
    [class.sa-stretch]="stretch" [class.sa-borderless]="borderless" [class.sa-dense]="dense"
    [class.sa-hide-subscript]="hideSubscript">

    <mat-label *ngIf="showLabel">{{ label }}</mat-label>

    <input #inputEl matInput type="text" [placeholder]="placeholder" [formControl]="control" [matAutocomplete]="auto"
        autocomplete="off" spellcheck="false" (keydown.enter)="onKeydownEnter($event)" />
    <mat-progress-spinner *ngIf="loading" matSuffix diameter="18" mode="indeterminate"></mat-progress-spinner>

    <button *ngIf="control.value" matSuffix mat-icon-button aria-label="Effacer" (click)="clear()">
        <mat-icon>close</mat-icon>
    </button>

    <button *ngIf="!control.value" id="btn-scan-bar-autocomplete" class="btn btn-link btn-wizard-trigger tooltip tooltip-left"
        [attr.data-tooltip]="translateService.instant('buttons.scanBarCode')" (click)="startScan()">
        <i class="fa fa-barcode"></i>
    </button>

    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayWith" [autoActiveFirstOption]="true"
        class="sa-autocomplete-panel" (opened)="onPanelOpened()"
        (optionSelected)="onOptionSelected($event.option.value)">
        <ng-container *ngIf="(options$ | async) as opts">
            <mat-option *ngFor="let opt of opts" [value]="opt">
                <div class="sa-option">
                    <img *ngIf="showImages && opt.img" class="sa-option__left-img" [src]="opt.img!"
                        [style.width.px]="imgSize" [style.height.px]="imgSize" [style.borderRadius.px]="imgRadius"
                        (error)="onImgErr($event)" />
                    <span class="sa-option__text">{{ opt.text }}</span>
                    <span *ngIf="opt.weight?.net" class="sa-option__weight">
                        {{ opt.weight.net }} {{ opt.weight.unit }}
                    </span>
                    <app-picto *ngIf="opt.picto != null" class="sa-option__right" [picto]="opt.picto">
                    </app-picto>
                </div>

            </mat-option>
            <mat-option *ngIf="!opts.length && !loading && !belowThreshold" (mousedown)="prepSelect()" disabled>
                Aucun résultat
            </mat-option>
        </ng-container>
    </mat-autocomplete>

</mat-form-field>